import { memoizeFunction, useTheme } from "@fluentui/react";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
import { Colors } from "@ms/uno-constants/lib/local/Colors";
/**
 * Get styles for icon button
 */ export const getIconButtonStyles = memoizeFunction(()=>{
    const theme = useTheme();
    const iconColor = theme.name === PlannerTheme.Light ? "inherit" : Colors.White;
    return {
        root: {
            color: iconColor,
            backgroundColor: "inherit"
        },
        rootHovered: {
            color: iconColor,
            backgroundColor: "inherit"
        },
        rootPressed: {
            color: iconColor,
            backgroundColor: "inherit"
        }
    };
});
export const getIconButtonWithCalloutStyles = memoizeFunction(()=>{
    return {
        root: {
            color: "inherit",
            backgroundColor: "inherit"
        }
    };
});
/**
 * Get styles for callout
 */ export const getCalloutStyles = memoizeFunction(()=>{
    return {
        width: "234px",
        height: "auto",
        padding: "2px 10px"
    };
});
